export const MemberDetails = {
  SKIP_SURCHARGE: 'skip_surcharge',
  MEMBERSHIP_PRICE: 'membershipPrice',
};
